import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag } from 'antd';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import SelectCenter from "../util/SelectCenter";
import Filter from '../util/Filter';
import { useSelector, useDispatch } from 'react-redux';
import PopupComponent from "../util/RatingPopup";
import moment from 'moment';
import setup from '../setup';

var clear = false;
var name = '';
var phone = '';
var filterMode = {
    name : true,
    phone : false
}

let storage = {
    nameKeyword : ''
}

export default function Rating() {
    const [showPopup, setShowPopup] = useState(false);
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();

    const columns = [
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname'
        },
        {
            title : '수업일자',
            dataIndex : 'class_date_time',
            key : 'class_date_time'
        },
        {
            title : '강사명',
            dataIndex : 'teacher',
            key : 'teacher'
        },
        {
            title : '평가분류',
            dataIndex : 'category',
            key : 'category'
        },
        {
            title : '평점',
            dataIndex : 'rating',
            key : 'rating'
        },
        {
            title : '등록일',
            dataIndex : 'regdate',
            key : 'regdate',
            render : regdate => {
                return moment(regdate).format('YYYY-MM-DD HH:mm')
            }
        }
    ];

    const onClickRow = (record) => {
        return {
            onClick : () => {
                openPopup("edit", record)
            }
        }
    }
    
    function openPopup(mode, data) {
        setShowPopup(true);
        storage.popupMode = mode;
        storage.popupData = data;
    }

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function handleClear(){
        storage.nameKeyword = '';
        clear = true;
        getDataSource();
    }

    function handleFilter(filterData){
        storage.nameKeyword = filterData.nameKeyword;
        getDataSource();
    }

    function closePopup(isUpdated) {
        setShowPopup(false);
        if(isUpdated === "updated"){
            getDataSource();
        }
    }

    function getDataSource(){
        if(clear === true){
            name = ''
        }else{
            name = storage.nameKeyword;
        }
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }

        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg_admin/get_rating', {
                cid: temp_cid,
                nameKeyword : name
            })
            setDataSource(result.data.rows);
            clear = false;
        })();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();   
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3 style={{display : "inline-block"}}>평가 관리</h3>
            <div className="content-component">
                <div className="content-header">
                <div></div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="table-header">
                        <div></div>
                        <div style={{display : "inline-flex"}}>
                        <Filter 
                            handleFilter = {handleFilter}   
                            handleClear = {handleClear}
                            mode = {filterMode}
                        />
                        </div>
                    </div>
                    <div className="table-body cursor">
                    <Table dataSource={dataSource} columns={columns} onRow={onClickRow}/>
                    </div>
                </div>
            </div>
            {showPopup ? 
            <PopupComponent
                data = {storage.popupData}
                mode = {storage.popupMode}
                closePopup={closePopup}
            />
            : null
            }
            </div>
            </div>
        </main>
    )
}